export default "__VITE_ASSET__D5dHP7rK__"